import { render, staticRenderFns } from "./OrganizationPointCharge.vue?vue&type=template&id=ed377b66&scoped=true&"
import script from "./OrganizationPointCharge.vue?vue&type=script&lang=js&"
export * from "./OrganizationPointCharge.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPointCharge.vue?vue&type=style&index=0&id=ed377b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed377b66",
  null
  
)

export default component.exports